import React from 'react';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import AccessGroupLtpPermit from './access/AccessGroupLtpPermit';
import AccessPermit from './access/AccessPermit';
import SalesOrderPermit from './salesOrder/SalesOrderPermit';
import { PermitContentWrapper } from './styles';
import WaitingListPermit from 'components/longTermParking/waitingList/WaitingListPermit';

const PermitTicketContent = ({
  permit,
  onPress,
}: {
  permit: UnifiedPermit;
  onPress?: () => void;
}) => {
  return (
    <PermitContentWrapper>
      {permit.permitType === 'ACCESS' && <AccessPermit permit={permit} />}
      {(permit.permitType === 'ACCESS_TO_MEMBER_GROUP_LTP' ||
        permit.permitType === 'DIGITAL_PERMIT') && (
        <AccessGroupLtpPermit permit={permit} onPress={onPress} />
      )}
      {permit.permitType === 'SALES_ORDER' && (
        <SalesOrderPermit permit={permit} onPress={onPress} />
      )}
      {permit.permitType === 'WAITING_LIST' && (
        <WaitingListPermit permit={permit} onPress={onPress} />
      )}
    </PermitContentWrapper>
  );
};

export default PermitTicketContent;
